// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_s-1";
export var movingGradient = "_s-4";
export var movingGradientBlock = "_s-2";
export var skeleton = "_s-0";
export var skeletonText = "_s-3";